import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'


Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        status: '',
        token: localStorage.getItem('token') || '',
        user: JSON.parse(localStorage.getItem('user') || "{}"),
    },
    mutations: {
        auth_request(state) {
            state.status = 'loading'
        },
        auth_success(state, input) {
            state.status = 'success'
            state.token = input.token
            state.user = input.user
        },
        auth_error(state) {
            state.status = 'error'
        },
        logout(state) {
            state.status = ''
            state.token = ''
            state.user = {}
        },
        set_default_location(state, location_id) {
            state.user.default_location = location_id
            localStorage.setItem('user', JSON.stringify(state.user))
        }
    },
    actions: {
        login({commit}, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                let url = process.env.VUE_APP_API
                url = url + "/user/login"
                axios({url: url, data: user, method: 'POST'})
                    .then(resp => {
                        const token = resp.data.data.token
                        const user = resp.data.data.user
                        localStorage.setItem('token', resp.data.data.token)
                        localStorage.setItem('user', JSON.stringify(user))
                        // Add the following line:
                        axios.defaults.headers.common['Authorization'] = 'Bearer '.concat(token)
                        commit('auth_success', {token, user})
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('auth_error')
                        localStorage.removeItem('token')
                        reject(err)
                    })
            })
        },
        changePassword({commit}, input) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                let data = {data: input}
                let url = process.env.VUE_APP_API
                url = url + "/user/password"
                axios.patch(url, data)
                    .then(resp => {
                        const token = resp.data.data.token
                        const user = resp.data.data.user
                        localStorage.setItem('token', resp.data.data.token)
                        localStorage.setItem('user', JSON.stringify(user))
                        // Add the following line:
                        axios.defaults.headers.common['Authorization'] = 'Bearer '.concat(token)
                        commit('auth_success', {token, user})
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('auth_error')
                        localStorage.removeItem('token')
                        reject(err)
                    })
            })
        },
        logout({commit}) {
            return new Promise((resolve, reject) => {
                commit('logout')
                localStorage.removeItem('token')
                delete axios.defaults.headers.common['Authorization']
                resolve()
            })
        }
    },
    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        getUser: state => state,
        default_location_name: state => {
            let found = '';
            state.user.locations.forEach(function (location) {
                if (location.id == state.user.default_location) {
                    found = location.location;
                }
            });
            return found
        },
        default_location_id: state => {
            return state.user.default_location
        },
        isAdmin: state => {
            let found = false;
            state.user.locations.forEach(function(location){
                let roles = location.roles;
                roles.forEach(function (role) {
                    if(role.role_id > 2)
                    {
                        found = true;
                    }
                })
            });
            return found;
        },
        isSuperAdmin: state => {
            let found = false;
            state.user.locations.forEach(function (location) {
                let roles = location.roles;
                roles.forEach(function (role) {
                    if(role.role_id === 4)
                    {
                        found = true;
                    }
                })
            });
            return found;
        },
        adminLocations: state => {
            let locations = [];
            state.user.locations.forEach(function (location) {
                let roles = location.roles;
                roles.forEach(function (role) {
                    if(role.role_id > 2)
                    {
                        locations.push(location);
                    }
                })
            });
            return locations;
        }
    }
})
